import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const SERVICE_QUATATIONS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    SERVICE_PROVIDERS: (orderId: number) => `/service-providers/${orderId}/`,
    ORDER_QUOTATIONS: (orderId: number) => `/order-quotations/${orderId}/`,
    CREATE_ORDER_QUOTATIONS: '/create-order-quotations/',
    SEND_ORDER_QUOTATION: '/send-order-quotation/',
  }),
} as const;
